import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const CalendarSlashIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={circled ? '50%' : '100%'}
      height={circled ? '50%' : '100%'}
      viewBox="0 0 22 22"
    >
      <g fill="none">
        <path
          d="M18.2941 18.2941H3.82353C3.47058 18.2941 3.23529 18.0588 3.23529 17.7059V5.47059C3.23529 5.11765 3.47058 4.88235 3.82353 4.88235H18.2941C18.6471 4.88235 18.8823 5.11765 18.8823 5.47059V17.8235C18.8823 18.1765 18.6471 18.4118 18.2941 18.4118V18.2941Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.7647 11H3.23529V5.47059C3.23529 5.11765 3.47058 4.88235 3.82353 4.88235H18.2941C18.6471 4.88235 18.8823 5.11765 18.8823 5.47059V11H18.7647Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.35294 3.70588V6.64706"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.647 3.70588V6.64706"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M21 1L1 21" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </g>
    </svg>
  </CircledIcon>
);
